// extracted by mini-css-extract-plugin
export default {"main":"PoData_main__WD9H-","table":"PoData_table__Bv2cf","tableHead":"PoData_tableHead__bopav","expandedTableHead":"PoData_expandedTableHead__tGES2"};